import React, { useState } from "react";
import {
  Box,
  Typography,
  FormControl,
  OutlinedInput,
  InputAdornment,
  IconButton,
  Button,
  Paper,
  Fade,
} from "@mui/material";
import { Eye, EyeOff } from "lucide-react";
import backgroundImage from "../../Pages/Image/kn.png";
import centralLogo from "../../Pages/Image/logo/kia-central-black.png";
import LoaderCon from "../../Common/loader/containers/loader_cont";
import Snackbar from "../../Common/snackbar/components/snackbar";
import { useDispatch } from "react-redux";
import { close_snack_bar } from "../../Common/snackbar/action";

const Login = ({ loginFetch, forgotpassword, snackbar }) => {
    const dispatch = useDispatch();
  const [forget, setForget] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = () => {
    loginFetch(email, password);
    setEmail("");
    setPassword("");
  };

  const handleForgotSubmit = () => {
    forgotpassword(email);
    setForget(false);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        p: { xs: 2, sm: 3 },
      }}
    >
      <Fade in>
        <Paper
          elevation={10}
          sx={{
            width: { xs: "100%", sm: "85%", md: 450 },
            p: { xs: 3, sm: 4 },
            borderRadius: 4,
            backdropFilter: "blur(10px)",
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            boxShadow: "0 8px 32px rgba(31,38,135,0.37)",
            border: "1px solid rgba(255, 255, 255, 0.18)",
          }}
        >
          {/* Logo and Title */}
          <Box sx={{ textAlign: "center", mb: 3 }}>
            <Box
              component="img"
              src={centralLogo}
              alt="Logo"
              sx={{
                height: { xs: 60, sm: 70, md: 80 },
                mb: 1.5,
              }}
            />
            <Typography variant="h5" fontWeight="bold" sx={{ color: "#000" }}>
              {forget ? "Forgot Password" : "Admin Login"}
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "#000", mt: 0.5, fontSize: { xs: "0.8rem", sm: "0.95rem" } }}
            >
              {forget
                ? "Reset your password using your email"
                : "Login to manage Central Kia Admin Panel"}
            </Typography>
          </Box>

          {/* Email Field */}
          <FormControl fullWidth margin="normal">
            <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500, color: "#000" }}>
              Email
            </Typography>
            <OutlinedInput
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              sx={{
                color: "#000",
                backgroundColor: "rgba(255,255,255,0.8)",
                borderRadius: 2,
                "& input::placeholder": { color: "#555", opacity: 1 },
                "& fieldset": { borderColor: "#ccc" },
                "&:hover fieldset": { borderColor: "#999" },
              }}
            />
          </FormControl>

          {/* Password Field */}
          {!forget && (
            <FormControl fullWidth margin="normal">
              <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500, color: "#000" }}>
                Password
              </Typography>
              <OutlinedInput
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                sx={{
                  color: "#000",
                  backgroundColor: "rgba(255,255,255,0.8)",
                  borderRadius: 2,
                  "& input::placeholder": { color: "#555", opacity: 1 },
                  "& fieldset": { borderColor: "#ccc" },
                  "&:hover fieldset": { borderColor: "#999" },
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword((prev) => !prev)}
                      edge="end"
                      sx={{ color: "#000" }}
                    >
                      {showPassword ? <EyeOff /> : <Eye />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          )}

          {/* Forgot / Back Link */}
          <Box textAlign="right" mb={2}>
            <Typography
              variant="body2"
              sx={{ color: "#1976d2", cursor: "pointer" }}
              onClick={() => setForget((prev) => !prev)}
            >
              {forget ? "Back to Login" : "Forgot password?"}
            </Typography>
          </Box>

          {/* Submit/Login Button */}
          <Button
            variant="contained"
            fullWidth
            sx={{
              mt: 1,
              py: 1.5,
              borderRadius: 3,
              fontWeight: "bold",
              backgroundColor: "#000",
              "&:hover": { backgroundColor: "#000" },
            }}
            onClick={forget ? handleForgotSubmit : handleLogin}
          >
            {forget ? "Submit" : "Login"}
          </Button>
        </Paper>
      </Fade>
      <LoaderCon />
      <Snackbar
        open={snackbar.response_received}
        close_snack_bar={() => dispatch(close_snack_bar())}
        message={snackbar.message}
      />

    </Box>
  );
};

export default Login;
